module.exports = __webpack_public_path__ + "img/f_2_1.c7aeff40.png";